var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('activity-review-form',{attrs:{"data":_vm.data,"model":_vm.model},on:{"onAutoSave":_vm.handleAutoSave,"onDetails":_vm.handleDetails}})}
var staticRenderFns = []

export { render, staticRenderFns }